import { createContext } from 'react';

export type ClipboardContextType = {
  copySuccessful: boolean;
  setCopySuccessful: (success: boolean) => void;
  selectedNodeIds: string[];
  setSelectedNodeIds: (ids: string[]) => void;
  handleCopy: (ids?: string[]) => void;
  copiedIds: number;
};

export const ClipboardContext = createContext<ClipboardContextType>({
  copySuccessful: false,
  setCopySuccessful: () => {},
  selectedNodeIds: [],
  setSelectedNodeIds: () => {},
  handleCopy: () => {},
  copiedIds: 0
});
